module.exports = __webpack_public_path__ + "static/img/code.dfc5790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/code.png
// module id = 2NfY
// module chunks = 10